import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e37fd36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { ElMenu } from 'element-plus'
import $store from '@/store'

function setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "nav",
    class: _normalizeClass({ collapse: _unref($store).state.collapse, 'nav-container': true })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref($store).state.collapse)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "nav-logo",
            src: _unref($store).state.project.logo
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "nav-logo mini",
            src: _unref($store).state.project.logo_square
          }, null, 8, _hoisted_3)),
      _createVNode(_unref(ElMenu), {
        "active-text-color": "#1989FA",
        "text-color": "#9497B1",
        "default-active": "0",
        mode: "vertical"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (i, k) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
              (!i.children)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.goRouter(i.path)),
                    index: '' + k
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass('nav-icon ' + i.meta.icon)
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(i.meta.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "index"]))
                : (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 1,
                    index: '' + k
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass('nav-icon ' + i.meta.icon)
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(i.meta.title), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.children, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: index,
                          index: k + '' + index,
                          onClick: ($event: any) => (_ctx.goRouter(item.path))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.meta.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["index", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
            ], 64))
          }), 128))
        ]),
        _: 1
      }),
      (_unref($store).state.collapse)
        ? (_openBlock(), _createElementBlock("i", {
            key: 2,
            class: "el-icon el-icon-s-unfold point menu-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref($store).commit('setCollapse', false)))
          }))
        : (_openBlock(), _createElementBlock("i", {
            key: 3,
            class: "el-icon el-icon-s-fold point menu-icon",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref($store).commit('setCollapse', true)))
          }))
    ])
  ], 2))
}
}


import { defineComponent } from 'vue'
const __default__ = defineComponent({
    props: ['active', 'list'],
    data () {
        return {
            menu: [
                {
                    name: '首页',
                    path: '/',
                    meta: {
                        title: '首页',
                        icon: 'el-icon-house'
                    }
                },
                {
                    name: '保险方案',
                    path: '/insurance/plan',
                    meta: {
                        title: '保险方案',
                        icon: 'el-icon-document-add'
                    }
                },
                {
                    name: '被派遣单位',
                    path: '/dispatch',
                    meta: {
                        title: '被派遣单位',
                        icon: 'el-icon-office-building'
                    }
                },
                {
                    name: '员工查询',
                    path: '/workers',
                    meta: {
                        title: '员工查询',
                        icon: 'el-icon-user'
                    }
                },
                {
                    name: '报案理赔',
                    path: '/report',
                    meta: {
                        title: '报案理赔',
                        icon: 'el-icon-help'
                    }
                },
                {
                    name: '费用及发票',
                    meta: {
                        title: '费用及发票',
                        icon: 'el-icon-document'
                    },
                    children: [
                        {
                            title: '账户充值',
                            path: '/recharge',
                            meta: {
                                title: '账户充值'
                            }
                        },
                        {
                            title: '充值记录',
                            path: '/recharge/record',
                            meta: {
                                title: '充值记录'
                            }
                        },
                        {
                            title: '发票记录',
                            path: '/invoice/record',
                            meta: {
                                title: '发票记录'
                            }
                        }
                    ]
                },
                {
                    name: '团队管理',
                    path: '/team',
                    meta: {
                        title: '团队管理',
                        icon: 'el-icon-suitcase'
                    }
                }
            ]
        }
    },
    async created () {
        // const menu = await getMenu()
        // this.menu = menu
        // console.log(menu)
    },
    methods: {
        goRouter (path: string) {
            this.$router.push({
                path
            })
        }
    }
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})